var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-centered"},[_c('div',[_vm._v(_vm._s(_vm.owner))]),_c('div',{staticClass:"mt-4"},[_c('button',{staticClass:"button",class:{ 'is-success': _vm.checked },on:{"click":_vm.onChecked}},[_vm._v("\n      checked\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }